<template>
	<div style="overflow-x: auto">
		<v-data-table
			class="elevation-0"
			mobile-breakpoint="0"
			:headers="headers"
			:items="filteredInvoices"
			:options.sync="options"
			:show-select="headerDict['_selected']"
			:loading="loading">
			<template v-slot:header>
				<tr>
					<th v-if="headerDict['_selected']"></th>
					<th v-for="(header, idx) in headers" :key="`header-${idx}`">
						<v-text-field
							dense
							class="ma-2"
							rounded
							v-model="filter[header.value]"
							placeholder="filter"
							solo-inverted
							hide-details
							flat></v-text-field>
					</th>
				</tr>
			</template>
			<template v-slot:[`header.data-table-select`]="{}">
				<v-checkbox class="pa-0" v-model="allSelected"></v-checkbox>
			</template>
			<template v-slot:[`item.data-table-select`]="{ item }">
				<v-checkbox
					class="pa-0"
					v-model="item._selected"
					@change="handleItemSelected(item)"></v-checkbox>
			</template>
			<template v-slot:[`item.id`]="{ item }">
				<a
					@click="
						$router.push({
							name: 'InvoiceUpdate',
							params: { id: item.id },
						})
					">
					{{ formatInvoiceId(item) }}
				</a>
			</template>
			<template v-slot:[`item.customerId`]="{ item }">
				<a
					@click="
						$router.push({
							name: 'CustomerUpdate',
							params: { id: item.customerId },
						})
					">
					{{ getCustomerName(item.customerId) }}
				</a>
			</template>
			<template v-slot:[`item.paymentStatusId`]="{ item }">
				<div
					:class="{
						'green--text': checkIfPaid(item.paymentStatusId),
						'red--text': !checkIfPaid(item.paymentStatusId),
					}">
					{{ getOptionName(item.paymentStatusId) }}
				</div>
			</template>
			<template v-slot:[`item.totalAmount`]="{ item }">
				<span class="mr-1">
					{{ getCurrencySymbol(item.currencyId) }}
				</span>
				<span>
					{{
						convertToCleanNumber(
							item.totalAmount,
							getCurrencySymbol(item.currencyId) == "$"
						)
					}}
				</span>
			</template>
			<template v-slot:[`item.amountDue`]="{ item }">
				<span class="mr-1">
					{{ getCurrencySymbol(item.currencyId) }}
				</span>
				{{
					convertToCleanNumber(
						item._amountDue,
						getCurrencySymbol(item.currencyId) == "$"
					)
				}}
				<span></span>
			</template>
			<template v-slot:[`item.collector`]="{ item }">
				<div>
					<span v-if="item.paymentStatusId == Paid">
						{{
							`${item.payments[0].collector.first} ${item.payments[0].collector.last}`
						}}
					</span>
				</div>
			</template>
			<template v-slot:[`item.createdBy`]="{ item }">
				<span>
					{{ getUserName(item.createdBy) }}
				</span>
			</template>
			<template v-slot:[`item.dateCreated`]="{ item }">
				{{ convertToDate(item.dateCreated) }}
			</template>
			<template v-slot:[`item.invoiceDate`]="{ item }">
				{{ convertToDate(item.invoiceDate, false) }}
			</template>
			<template v-slot:[`item.amountReceived`]="{ item }">
				<v-text-field
					dense
					rounded
					outlined
					v-model.number="item._amountReceived"
					hide-details></v-text-field>
			</template>
		</v-data-table>
	</div>
</template>
<script>
//import Decimal from "decimal.js";
import generalMixin from "@/js/general-mixin";
import eventBus from "@/js/event-bus.js";

import { CurrencyType, PaymentStatus } from "@/js/enum.js";
export default {
	name: "InvoiceList",
	mixins: [generalMixin],
	mounted: function () {
		eventBus.$on("generateCsv", this.generateCsv);
	},
	props: {
		value: {
			type: Array,
			default: () => {
				return [];
			},
		},
		customHeaders: {
			type: Array,
			default: () => {
				return [];
			},
		},
		loading: {
			type: Boolean,
			default: () => {
				return false;
			},
		},
	},
	data() {
		return {
			defaultHeaders: [
				{
					text: "Id",
					align: "start",
					value: "id",
					width: 100,
				},
				{
					text: "Tracking #",
					align: "start",
					value: "mtlTracking",
					width: 100,
				},
				{ text: "Customer", value: "customerId", width: 200 },
				{ text: "Description", value: "description", width: 200 },
				{ text: "Box/Case/Pallet", value: "boxCasePallet", width: 100 },
				{ text: "Weight", value: "weight", width: 100 },
				{
					text: "Total Amount",
					value: "totalAmount",
					align: "end",
					width: 150,
				},
				{ text: "Payment", value: "paymentStatusId", width: 100 },
				//{ text: 'Collector', value: 'collector', width: 200 },
				{ text: "Created By", value: "createdBy", width: 120 },
				{ text: "Date Created", value: "dateCreated", width: 200 },
				{ text: "Invoice Date", value: "invoiceDate", width: 100 },
			],
			selected: [],
			allSelected: false,
		};
	},
	computed: {
		Paid() {
			return this.getIdByEnum(PaymentStatus.Paid);
		},
		headerDict() {
			let headerDict = {};
			this.customHeaders.forEach((e) => {
				headerDict[e] = true;
			});
			return headerDict;
		},
		headers() {
			let headers = [];
			if (this.customHeaders.length == 0) return this.defaultHeaders;
			headers = this.defaultHeaders.filter(
				(e) => this.headerDict[e.value]
			);
			if (this.headerDict["_amountDue"]) {
				headers.push({
					text: "Amount Due",
					value: "amountDue",
					width: 150,
					align: "end",
				});
			}
			if (this.headerDict["_amountReceived"]) {
				headers.push({
					text: "Amount Received",
					value: "amountReceived",
					width: 150,
				});
			}

			return headers;
		},
		invoices: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			},
		},
		filteredInvoices() {
			let invoices = this.invoices;
			for (let key in this.filter) {
				let searchStr = this.filter[key].trim().toLowerCase();
				let header = this.headers.find((header) => header.value == key);
				if (header && searchStr && searchStr.length) {
					invoices = invoices.filter((e) => {
						let str = this.getDataText(header, e);
						return str
							.toString()
							.trim()
							.toLowerCase()
							.includes(this.filter[key].toLowerCase());
					});
				}
			}
			return invoices;
		},

		filter: {
			get() {
				return this.$store.getters["interactStore/invoiceFilter"];
			},
			set(val) {
				return this.$store.commit(
					"interactStore/setInvoiceFilter",
					val
				);
			},
		},
		options: {
			get() {
				return this.$store.getters["interactStore/invoiceOptions"];
			},
			set(val) {
				return this.$store.commit(
					"interactStore/setInvoiceOptions",
					val
				);
			},
		},
	},
	methods: {
		generateCsv() {
			let headerStr =
				"Id;Tracking #;Customer;Description;Box/Case/Pallet;Weight;Total Amount;Payment;Date Created";
			let csvContent = "";
			csvContent += headerStr + "\r\n";
			for (let i = 0; i < this.filteredInvoices.length; i++) {
				const invoice = this.filteredInvoices[i];
				let rowStr =
					`${invoice.id};${
						invoice.mtlTracking
					};${this.getCustomerName(invoice.customerId)}` +
					`;${invoice.description};${invoice.boxCasePallet};${
						invoice.weight
					};${this.convertToCleanNumber(invoice.totalAmount)}` +
					`;${this.getOptionName(
						invoice.paymentStatusId
					)};${this.convertToDate(invoice.dateCreated, false)}`;
				csvContent += rowStr + "\r\n";
			}
			let blob = new Blob([csvContent], { type: "text/plain" });
			let url = URL.createObjectURL(blob);
			let link = document.createElement("a");
			link.setAttribute("href", url);
			link.setAttribute("download", `invoice-list.csv`);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		getDataText(header, invoice) {
			if (header.value == "id") {
				return this.formatInvoiceId(invoice);
			} else if (header.value == "mtlTracking") {
				return invoice.mtlTracking ? invoice.mtlTracking : "";
			} else if (header.value == "customerId") {
				return this.getCustomerName(invoice.customerId);
			} else if (header.value == "description") {
				return invoice.description;
			} else if (header.value == "boxCasePallet") {
				return invoice.boxCasePallet;
			} else if (header.value == "weight") {
				return invoice.weight.toString();
			} else if (header.value == "totalAmount") {
				return invoice.totalAmount.toString();
			} else if (header.value == "paymentStatusId") {
				return this.getOptionName(invoice.paymentStatusId);
			} else if (header.value == "collector") {
				if (invoice.paymentStatusId == this.Paid) {
					return `${invoice.payment.collector.first} ${invoice.payment.collector.last}`;
				} else {
					return "";
				}
			} else if (header.value == "dateCreated") {
				return this.convertToDate(invoice.dateCreated);
			} else if (header.value == "invoiceDate") {
				return this.convertToDate(invoice.invoiceDate, false);
			} else if (header.value == "createdBy") {
				return this.getUserName(invoice.createdBy);
			} else {
				return "";
			}
		},

		getCurrencySymbol(currencyId) {
			let us = this.getIdByEnum(CurrencyType.UsDollar);
			let viet = this.getIdByEnum(CurrencyType.VietDong);
			if (currencyId == us) {
				return "$";
			} else if (currencyId == viet) {
				return "₫";
			}
			return "";
		},
		handleItemSelected(item) {
			// if (item._selected)
			// 	item._amountReceived = new Decimal(item._amountDue);
			if (!item._selected) item._amountReceived = null;
			this.$emit("distribute-amount-received");
		},
	},
	destroyed: function () {
		eventBus.$off("generateCsv");
	},
	watch: {
		allSelected: function (newVal, oldVal) {
			oldVal;
			if (newVal) {
				this.invoices.forEach((e) => (e._selected = true));
				this.$forceUpdate();
			} else {
				this.invoices.forEach((e) => (e._selected = false));
				this.$forceUpdate();
			}
		},
	},
};
</script>
<style>
.payment-paid {
  background-color: lightgreen;
}
</style>
